<script setup>

import {computed, onMounted, reactive, ref} from "vue";
import { useNotificationStore } from '@/stores/NotificationStore.js'
const notificationStore = useNotificationStore()

const emit = defineEmits('created')

const notificationContent = reactive({
    title: '',
    body: '',
    tags: [],
    datetime: new Date()
})
const state = ref('')
const tagSelector = ref()

const onDateSelected = (e) => {
    notificationContent.datetime = e;
}

const onTagLeadTagsSelected = (e) => {
    notificationContent.tags = e.map(tag => tag.id);
}

const notificationValidates = computed(() => {
    return notificationContent.title && notificationContent.body && notificationContent.datetime && notificationContent.tags.length > 0;
})

const createNotification = async () => {
    if (!notificationValidates.value) {
        return;
    }

    state.value = 'waiting'

    const res = await axios.post(route('api.manage-whitelabel-app.store-notification'), notificationContent)

    if (res.data.success) {
        state.value = 'success'
    } else {
        state.value = 'error'
    }
    emit('created')
    resetNotificationContent();

    notificationStore.addNotification({
        type: 'success',
        message: _mft('whitelabelApp:notification.created.confirmation.title'),
        dismissAfter: 5000,
    })

    window.scrollTo(0, 0);
}

const resetNotificationContent = () => {
    notificationContent.title = '';
    notificationContent.body = '';
    notificationContent.tags = [];
    notificationContent.datetime = new Date();

    tagSelector.value.clearSelectedTags()
}

onMounted(() => {
    const date = new Date();
    date.setHours(date.getHours() + 1);
    date.setMinutes(15);
    date.setSeconds(0);
    date.setMilliseconds(0);
    notificationContent.datetime = date;
})

</script>
<template>
    <card-basic>
        <template #header>
            <h1>{{ _mft('whitelabelApp:notification.createNew.title') }}</h1>
        </template>
        <div class="grid grid-cols-1 gap-y-12">
            <div>
                <h2>Content</h2>
                <div class="grid md:grid-cols-2 gap-8 items-center">
                    <div class="">
                        <input-text
                            :label="_mft('whitelabelApp:notification.title.label')"
                            maxlength="40"
                            v-model:content="notificationContent.title"
                        ></input-text>

                        <input-textarea
                            :label="_mft('whitelabelApp:notification.body.label')"
                            :maxlength="150"
                            v-model:content="notificationContent.body"
                        ></input-textarea>
                    </div>
                    <div class="flex justify-center transition-all" :class="notificationContent.title || notificationContent.body ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'">
                        <div class="bg-white rounded-lg shadow-lg w-full max-w-xs p-2 flex space-x-4 items-center">
                            <div class="h-10 aspect-square bg-gradient-to-b from-gray-200 to-gray-300 rounded-md"></div>
                            <div>
                                <div class="text-xs font-bold">{{ notificationContent.title }}</div>
                                <div class="text-xs">{{ notificationContent.body }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <h2>Recipients</h2>
                <tags-multi-select
                    ref="tagSelector"
                    @tagsSelected="onTagLeadTagsSelected"
                    :placeholder="_mft('whitelabelApp:notification.tags.search')"
                    :allow-creation="true"
                    :select-multiple="true"
                ></tags-multi-select>
            </div>

            <div>
                <h2 class="mb-2">Delivery</h2>
                <input-datepicker
                    :date="notificationContent.datetime"
                    :minutes-increment="15"
                    :show-time="true"
                    @update:date="onDateSelected"
                ></input-datepicker>
            </div>
            <div class="flex justify-center">
                <button-success
                    :disabled="! notificationValidates"
                    @click="createNotification"
                >
                    {{ _mft('whitelabelApp:notification.create.label') }}
                </button-success>
            </div>
        </div>
    </card-basic>
</template>
